module.exports = __webpack_public_path__ + "static/product-logo-aws-26c7f4eb6c67bb4a82ca0b4a1e692da3.png";